module.exports = __webpack_public_path__ + "img/home_icon_wtechnicaldepartment@2x.31165151.png";